import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgInfo = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx={7.5} cy={7.5} r={7} stroke="currentColor" />
    <path
      d="M7.5 11.5V6M7.8 3.5a.3.3 0 1 1 0-.019"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
